import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from '@hooks/useTranslation';

const FormAddPage = lazy(() => import('@features/form-builder/FormAddPage'));

interface FormAddSearch {
  id?: string;
}

function FormAddRoute() {
  const { t } = useTranslation();
  return (
    <Suspense
      fallback={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
          {t('K_LOADING', 'Loading...')}
        </div>
      }
    >
      <FormAddPage />
    </Suspense>
  );
}

export const Route = createFileRoute('/w/form/add')({
  staticData: { breadcrumb: 'Create Form', breadcrumbKey: 'K_BREADCRUMB_CREATE_FORM' },
  validateSearch: (search: Record<string, unknown>): FormAddSearch => ({
    id: typeof search.id === 'string' ? search.id : undefined,
  }),
  component: FormAddRoute,
});
